import React from "react";
import "./EmployerMatchingFooter.scss";

/**
 * @param {object} props - The component props.
 * @param {string} props.providerLogoSrc - The source URL of the provider logo.
 * @param {string} props.providerLabel - The label for the provider.
 * @returns {React.JSX.Element} The rendered employer matching footer component.
 */
const EmployerMatchingFooter = ({ providerLogoSrc, providerLabel }) => (
    <div className="gift-matching__poweredby">
        <span>Powered by</span>
        <img src={providerLogoSrc} alt={providerLabel} />
    </div>
);

export default EmployerMatchingFooter;
